import { Card } from "react-bootstrap";

function AboutCard({ image, title, para }) {
    return (
        <Card className="shadow-sm rounded-4 border-0 p-4 pb-2 h-100 ">
            <div className="ms-3" style={{ height: "50px", width: "50px" }}>
                <Card.Img variant="top" src={image} className="w-100" />
            </div>
            <Card.Body className="d-flex flex-column">
                <Card.Title className="mb-3">
                    <strong>
                        {title}
                    </strong>  
                      </Card.Title>
                <div className="flex-grow-1">
                    {para && <>{para}</>}
                </div>
            </Card.Body>
        </Card>
    );
}

export default AboutCard;
